import React from 'react';
import { ShoppingCartIcon, RocketIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const MerchPreview = () => {
  // Function to scroll to newsletter with proper offset
  const scrollToNewsletter = () => {
    const newsletterElement = document.getElementById('newsletter');
    if (newsletterElement) {
      const header = document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 0;
      const elementPosition = newsletterElement.offsetTop;
      const offsetPosition = elementPosition - headerHeight - 20;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-28 md:pt-36 pb-16" data-id="element-514">
      <div className="max-w-6xl mx-auto" data-id="element-515">
        <h2 className="text-5xl font-bold mb-12 font-mono text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-purple-400 inline-block" data-id="element-516">
          MERCH
        </h2>
        <div className="bg-black/60 backdrop-blur-sm rounded-lg border border-indigo-500/30 shadow-lg shadow-indigo-500/20 overflow-hidden" data-id="element-517">
          <div className="p-8 md:p-12 flex flex-col items-center text-center" data-id="element-518">
            <div className="w-24 h-24 rounded-full bg-gradient-to-r from-pink-600 to-purple-600 flex items-center justify-center mb-8 shadow-lg shadow-pink-500/30" data-id="element-519">
              <ShoppingCartIcon size={48} className="text-white" data-id="element-520" />
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-521">
              FABRIC REALITY MERCH STORE
            </h3>
            <div className="inline-block px-4 py-1 bg-pink-600/20 border border-pink-500/30 rounded-full text-pink-400 font-mono text-sm mb-6" data-id="element-522">
              COMING SOON
            </div>
            <p className="text-gray-300 text-lg md:text-xl max-w-2xl mb-8" data-id="element-523">
              Our official merchandise store is currently under construction.
              Sign up for our newsletter to be the first to know when exclusive
              Fabric Reality merch becomes available.
            </p>
            <div className="grid gap-8 md:grid-cols-3 w-full max-w-3xl mb-10" data-id="element-524">
              <div className="bg-purple-900/20 p-6 rounded-lg border border-purple-500/20" data-id="element-525">
                <h4 className="text-xl text-pink-300 mb-3" data-id="element-526">
                  T-Shirts & Apparel
                </h4>
                <p className="text-gray-300" data-id="element-527">
                  Limited edition designs featuring cosmic artwork and band
                  logos
                </p>
              </div>
              <div className="bg-purple-900/20 p-6 rounded-lg border border-purple-500/20" data-id="element-528">
                <h4 className="text-xl text-pink-300 mb-3" data-id="element-529">Vinyl & Music</h4>
                <p className="text-gray-300" data-id="element-530">
                  Physical releases with exclusive artwork and limited pressings
                </p>
              </div>
              <div className="bg-purple-900/20 p-6 rounded-lg border border-purple-500/20" data-id="element-531">
                <h4 className="text-xl text-pink-300 mb-3" data-id="element-532">Accessories</h4>
                <p className="text-gray-300" data-id="element-533">
                  Posters, pins, and other cosmic collectibles from Fabric
                  Reality
                </p>
              </div>
            </div>
            <Link to="/#newsletter" onClick={e => {
            e.preventDefault();
            scrollToNewsletter();
          }} className="group relative px-8 py-4 bg-gradient-to-r from-pink-600 to-purple-600 text-white font-bold text-lg rounded-lg transition-all duration-300 hover:from-pink-500 hover:to-purple-500 hover:shadow-lg hover:shadow-pink-500/30 transform hover:scale-105 flex items-center" data-id="element-534">
              <span className="mr-2" data-id="element-535">CLICK HERE TO GET NOTIFIED</span>
              <ArrowRightIcon size={20} className="transition-transform group-hover:translate-x-1" data-id="element-536" />
              <div className="absolute -inset-0.5 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg blur opacity-30 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-tilt" data-id="element-537"></div>
            </Link>
            <div className="mt-10 flex items-center justify-center" data-id="element-538">
              <RocketIcon size={16} className="text-pink-400 mr-2" data-id="element-539" />
              <p className="text-gray-400 text-sm" data-id="element-540">
                Merch store currently in development — check back soon!
              </p>
            </div>
          </div>
        </div>
        <div className="mt-12 p-6 bg-black/40 backdrop-blur-sm rounded-lg border border-indigo-500/10" data-id="element-541">
          <h3 className="text-xl font-semibold text-white mb-4" data-id="element-542">
            Merchandise Inquiries
          </h3>
          <p className="text-gray-300" data-id="element-543">
            For wholesale, custom, or special merchandise requests, please
            contact us at{' '}
            <span className="text-pink-400" data-id="element-544">merch@fabricreality.com</span>
          </p>
        </div>
      </div>
    </section>;
};
export default MerchPreview;